<template>
    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 0.0771484H13C12.7348 0.0771484 12.4804 0.182505 12.2929 0.370042C12.1054 0.557578 12 0.811932 12 1.07715V18.0691H16V1.07715C16 0.811932 15.8946 0.557578 15.7071 0.370042C15.5196 0.182505 15.2652 0.0771484 15 0.0771484ZM9 6.07715H7C6.73478 6.07715 6.48043 6.1825 6.29289 6.37004C6.10536 6.55758 6 6.81193 6 7.07715V18.0691H10V7.07715C10 6.81193 9.89464 6.55758 9.70711 6.37004C9.51957 6.1825 9.26521 6.07715 9 6.07715ZM3 12.0771H1C0.734783 12.0771 0.48043 12.1825 0.292893 12.37C0.105357 12.5576 0 12.8119 0 13.0771V18.0691H4V13.0771C4 12.8119 3.89464 12.5576 3.70711 12.37C3.51957 12.1825 3.26522 12.0771 3 12.0771Z" fill="white"/>
        </svg>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>
